<template>
  <div id="app" :class="langBool?'app1':'app2'">
     <el-backtop class="backtop" :bottom="200">
       <img src="../static/image/top.png" alt="" srcset="" title="返回顶部">
     </el-backtop>
    <router-view name="header"></router-view>
    <el-container style="flex-direction: inherit!important;width: 100%;">
      <router-view name="left"></router-view>

      <el-main>
        <fade-transition
          origin="center"
          mode="out-in"
          :duration="250"
        >

          <router-view />
        </fade-transition>
      </el-main>
    </el-container>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
import { FadeTransition } from "vue2-transitions";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
  components: {
    FadeTransition
  },
  data() {
    return {
      langBool: true,//判断使用哪种字体

    };
  },
  computed: {
    ...mapState("user", ["packUnfold"])
  },
  methods: {
    ...mapMutations("user", ["SET_PACKUNFOLD"])
    
  },
  created() {
    // var lang=sessionStorage['lang']
    // if(!lang || lang==1){
    //   this.langeBool =true
    // }else{
    //   this.langBool=false
    // }
  }
};
</script>
<style lang="scss">
@import "./assets/custom/common.scss";
// @import "./assets/font/font.css";
.el-header,
.el-footer {
  // background-color: #006cc8;
  color: #333;
  /* text-align: center; */
  /* line-height: 60px; */
}
.el-container {
  flex-direction: column;
  min-height: 100%;
  position: relative;
}
.el-main {
  /* height: 100%; */
  padding: 0px !important;
  overflow-x: hidden !important;
  // scrollbar-width: none; /* firefox */
  // -ms-overflow-style: none; /* IE 10+ */
  // overflow-y: hidden;
  // overflow-x: auto;
  // &::-webkit-scrollbar {
  //   display: none; /* Chrome Safari */
  // }
}
#app{
  /deep/ .el-icon-caret-top{
    color:#1C3278;
  }
  .backtop{
    width: 60px;
    height: 60px;
    font-size: 0px;
    border-radius: 5px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.app1 {
  font-family: "STXinwei";
  button {
    font-family: "STXinwei";
  }
  input{
    font-family: "STXinwei";
  }
}
.app2 {
  font-family: "Arial";
  button {
    font-family: "Arial";
  }
  input{
    font-family: "Arial";
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue